<template>
  <div class="news-template-container">
    <div class="news-template"></div>
  </div>
</template>

<script>
    export default {
      name: "index",
      data(){
          return{
            headerActive: null
          }
      },
    }
</script>

<style scoped>
.news-template-container{
  width: 100%;
  background-color: #fafbfc;
  min-height: 78%;
  min-height: calc(100% - 220px);
  min-height: -moz-calc(100% - 220px);
  min-height: -webkit-calc(100% - 220px);
}
.news-template{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/newsTemplate/index.vue